(function () {
  'use strict';
  angular.module('providerPortal')
    .component('footerComponent', {
        templateUrl: 'js/general/footer.html' + appVersion,
        controller: ['$translate',
          function footerController($translate) {
            this.year = moment().format('YYYY');
          }]
        }
    );
})();
